import React from "react";
import { Award } from "lucide-react";

// Sprint 12+ Phase 4 (Task Skeleton, 30.06.2026) — Pionier-Badge
// Zeigt „Pionier"-Badge im Cockpit-Header wenn user.is_pionier === true.
// Tooltip: "Du bist einer der Ersten. Danke, dass du Flex4Success mitgestaltest."
//
// Sprint-V24 Hotfix (11.09.2026, Andreas-Direktive „Mobile-Breite"):
// Auf Mobile (<sm) nur noch kompaktes rundes Gold-Emblem (Icon-only),
// damit die TopBar keine Breite von unten wegnimmt. Ab sm: unveraendert
// mit „Pionier"-Text.
//
// Props:
//   user: { is_pionier: boolean, pionier_since?: string }

// Sprint V26 (Fr 27.02.2026) — TopBar-Cleanup Option A:
// Mobile-Emblem entfernt, damit das TopBar-Logo nicht mehr gequetscht wird.
// Pionier-Kennzeichnung erscheint auf Mobile jetzt im Avatar-Dropdown-Header
// (siehe RedesignTopBar.jsx). Desktop unveraendert.
export default function PionierBadge({ user }) {
  if (!user?.is_pionier) return null;
  const tooltip = "Du bist einer der Ersten. Danke, dass du Flex4Success mitgestaltest.";
  return (
    <span
      data-testid="pionier-badge"
      title={tooltip}
      className="hidden sm:inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-amber-400 to-amber-500 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider text-white shadow-sm"
    >
      <Award className="w-3 h-3" aria-hidden="true" />
      Pionier
    </span>
  );
}
